export default __webpack_public_path__ + "static/media/IMG3.b31c9a82.png";